import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Clock, CheckCircle2 } from 'lucide-react';

const iconMap = {
  clock: Clock,
  alert: AlertCircle,
  check: CheckCircle2,
};

function StatusBanner({ 
  title, 
  message, 
  statusFlow = null, 
  icon = 'clock'
}) {
  const Icon = iconMap[icon];

  return (
    <Card className="border-primary/30 bg-primary/5">
      <CardContent className="py-4 sm:py-6 flex items-start gap-3 sm:gap-4">
        <Icon className="h-6 w-6 sm:h-8 sm:w-8 text-primary mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <h3 className="text-base sm:text-lg font-semibold text-primary leading-tight">{title}</h3>
          <p className="text-xs sm:text-sm text-muted-foreground mt-1 leading-relaxed">{message}</p>
          {statusFlow && (
            <div className="mt-2 sm:mt-3 flex items-start gap-1.5 sm:gap-2 text-[11px] sm:text-xs text-muted-foreground">
              <AlertCircle className="h-3 w-3 sm:h-4 sm:w-4 mt-0.5 shrink-0" />
              <span className="leading-relaxed">{statusFlow}</span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}

export default StatusBanner;
